<template>
  <aw-dropdown
    placement="bottom-end"
    :offset="[0, 6]"
    class="relative cursor-pointer hidden lg:inline-flex items-center"
  >
    <template v-slot:btn="{ toggle }">
      <div @click="toggle" class="inline-flex items-center">
        <img 
          :src="'/assets/gfx/flags/' + $presenter.language.lang +'.svg'" 
          class="w-5 h-5" 
          :alt="$t('Selected language')" 
        />
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--HeaderLangs Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
      >
        <nav class="p-0">
          <slot />
        </nav>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped></style>
